module.exports = __webpack_public_path__ + "img/img1.ca8d447f.jpg";